import React, { Component, Fragment, useEffect } from 'react'
import Datetime from 'react-datetime';
import Select from 'react-select';
import NotificationSystem from 'react-notification-system';
import { postWithHeaders, get } from '../../../server/actions';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { getCalendarSchoolYear } from '../../../server/utilDistrict';
import '../../../assets/css/applicationSettings.css';
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import PropTypes from 'prop-types';

const samplingType = [
    { value: 'Standard', label: 'Standard' },
    { value: 'Alternate1', label: 'Alternate 1' },
    { value: 'Atlernate2', label: 'Alternate 2 / Focus' }
];

const options = [
    { value: 'EveryWeek', label: 'Every Week' },
    { value: 'EveryTwoDays', label: 'Every 2 Days' },
    { value: 'Monthly', label: 'Monthly' },
];

const Checkbox = ({ label, checked, onChange }) => {
    return (
        <div className="checkbox-container">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <span className="checkbox-label">{label}</span>
        </div>
    );
};

class applicationSetting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSchoolsFilter: false,
            selectSchool: 0,
            selectAllSchools: false,
            schoolList: [],
            name: '',
            phone: '',
            email: '',
            startDate: new Date(`${getCalendarSchoolYear()}-10-1`),
            endDate: new Date(`${getCalendarSchoolYear()}-11-30`),
            samplingType: null,
           // followupFrequency: null,
            isEmail: false,
            isSms: false,
            checkboxStates: {},
            active: true,
            searchKey: '',

        }
    }


    clearAll = () => {
        this.setState({
            showSchoolsFilter: false,
            selectSchool: 0,
            selectAllSchools: false,
            name: '',
            phone: '',
            email: '',
            startDate: null,
            endDate: null,
            samplingType: null,
            //followupFrequency: null,
            isEmail: false,
            isSms: false,
            checkboxStates: {},
            active: true,
            appStatus: ''
        })
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    componentWillMount() {
        this.props.changeShowHideSchoolFitler(false);
        const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loggedInUserDetails'));
        const updatedCheckboxes = {}

        if (loggedInUserDetails && loggedInUserDetails.schools) {
            const schoolsObject = loggedInUserDetails.schools;

            const schoolsArray = Object.keys(schoolsObject).map(schoolId => ({
                schoolId: schoolsObject[schoolId].schoolId,
                schoolName: schoolsObject[schoolId].schoolName
            }));

            schoolsArray.forEach(school => {
                updatedCheckboxes[school.schoolId] = false;
            });

            this.setState({ schoolList: schoolsArray, checkboxStates: updatedCheckboxes, selectAllSchools: false }, () => {

            });
        }


        this.getSettingsInfo()
    }

    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }

    handleCheckboxChange = (checkboxId) => {
        this.setState(prevState => {
            const updatedCheckboxes = {
                ...prevState.checkboxStates,
                [checkboxId]: !prevState.checkboxStates[checkboxId]
            };

            const allCheckboxesChecked = Object.values(updatedCheckboxes).every(checkbox => checkbox);

            return {
                checkboxStates: updatedCheckboxes,
                selectAllSchools: allCheckboxesChecked
            };
        });
    };

    handleSelectAllChange = () => {

        this.setState(prevState => {

            console.log("Prev State: ", prevState)
            const updatedCheckboxes = {};

            Object.keys(prevState.checkboxStates).forEach(checkboxId => {
                updatedCheckboxes[checkboxId] = !prevState.selectAllSchools;
            });

            return {
                selectAllSchools: !prevState.selectAllSchools,
                checkboxStates: updatedCheckboxes
            };
        });
    };



    handleCheckboxEmail = () => {
        this.setState({ isEmail: !this.state.isEmail })
    };


    handleCheckboxSms = () => {
        this.setState({ isSms: !this.state.isSms })
    };

    handleSamplingType = (selectedOption) => {
        this.setState({ samplingType: selectedOption });
    };

    // handleFollowUpFrequency = (selectedOption) => {
    //     this.setState({ followupFrequency: selectedOption });
    // };



    setSamplingType = (key) => {
        const final = samplingType.find(ele => ele.value === key)
        this.setState({ samplingType: final });
    };

    setFollowupFrequency = (key) => {
        const final = options.find(ele => ele.value === key)
        this.setState({ followupFrequency: final });
    };

    getSettingsInfo = async () => {

        let districtId = sessionStorage.getItem('districtId');
        let verificationYear = getCalendarSchoolYear()
        await get(`/householdAppVerifySetup/${districtId}/${verificationYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let selectedSchools = data.includedSchools.split(',')
            selectedSchools.map(id => {
                this.handleCheckboxChange(id)
            })
            this.setSamplingType(data.samplingType)
            //this.setFollowupFrequency(data.followupFrequency)
            this.setState({
                name: data.name,
                email: data.email,
                phone: data.contactNo,
                isEmail: data.followupCommTypeEmail,
                isSms: data.followupCommTypeSMS,
                startDate: data.verificationStartDate,
                endDate: data.verificationEndDate,
                appStatus: data.status
            })
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
    }

    saveVerifySettings = () => {
        const selectedSchools = this.state.schoolList.filter(school => this.state.checkboxStates[school.schoolId]).map(school => school.schoolId);

        if (this.state.startDate == null) {
            _addNotificationError('Please select Verification Start Date', this);
        } else if (this.state.endDate == null) {
            _addNotificationError('Please select Verification End Date', this);
        } else if (this.state.samplingType == null) {
            _addNotificationError('Please select Sampling Type', this);
        } else if (this.state.name == '') {
            _addNotificationError('Please fill the Name field', this);
        } else if (this.state.phone == '') {
            _addNotificationError('Please fill the Phone field', this);
        } else if (this.state.email == '') {
            _addNotificationError('Please fill the Email field', this);
        } else if (selectedSchools.length < 1) {
            _addNotificationError('Please select atleast one School', this);
        } else {

            let headers = {
                'Content-Type': 'application/json'
            };

            let districtId = sessionStorage.getItem('districtId');

            const requestBody = {
                'verificationYear': getCalendarSchoolYear(),
                'name': this.state.name,
                'contactNo': this.state.phone,
                'email': this.state.email,
                'verificationStartDate': this.state.startDate,
                'verificationEndDate': this.state.endDate,
                'samplingType': this.state.samplingType.value,
                //'followupFrequency': this.state.followupFrequency.value,
                'followupCommTypeEmail': this.state.isEmail,
                'followupCommTypeSMS': this.state.isSms,
                'includedSchools': selectedSchools.join(','),
                'active': this.state.active,
            }

            // Post method to send data to backend

            postWithHeaders(`/householdAppVerifySetup/${districtId}?access_token=`, JSON.stringify(requestBody), headers).then((response) => {
                if (response.status === 200) {
                    this.setState({ loading: false })
                    _addNotification('Verification Setup has been saved successfully.', this);
                    setTimeout(() => { this.context.router.history.push('/'); }, 2000);
                } else if (!response.ok) {
                    console.log("Error Response: ", response)
                    throw Error(response.status);
                } else {
                    _addNotificationError('Check your request body', this);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(`Failed to verify household apps! Getting ${error} status. Please check API request`, this);
                }
            );
        }

    }


    handleVerify = () => {
        const selectedSchools = this.state.schoolList.filter(school => this.state.checkboxStates[school.schoolId]).map(school => school.schoolId);

        if (this.state.startDate == null) {
            _addNotificationError('Please select Verification Start Date', this);
        } else if (this.state.endDate == null) {
            _addNotificationError('Please select Verification End Date', this);
        } else if (this.state.samplingType == null) {
            _addNotificationError('Please select Sampling Type', this);
        } else if (this.state.name == '') {
            _addNotificationError('Please fill the Name field', this);
        } else if (this.state.phone == '') {
            _addNotificationError('Please fill the Phone field', this);
        } else if (this.state.email == '') {
            _addNotificationError('Please fill the Email field', this);
        } else if (selectedSchools.length < 1) {
            _addNotificationError('Please select atleast one School', this);
        } else {

            let headers = {
                'Content-Type': 'application/json'
            };

            let districtId = sessionStorage.getItem('districtId');

            const requestBody = {
                'verificationYear': getCalendarSchoolYear(),
                'name': this.state.name,
                'contactNo': this.state.phone,
                'email': this.state.email,
                'verificationStartDate': this.state.startDate,
                'verificationEndDate': this.state.endDate,
                'samplingType': this.state.samplingType.value,
                //'followupFrequency': this.state.followupFrequency.value,
                'followupCommTypeEmail': this.state.isEmail,
                'followupCommTypeSMS': this.state.isSms,
                'includedSchools': selectedSchools.join(','),
                'active': this.state.active,
            }

            // Post method to send data to backend

            postWithHeaders(`/householdAppVerifySetup/${districtId}?access_token=`, JSON.stringify(requestBody), headers).then((response) => {
                if (response.status === 200) {
                    this.setState({ loading: false })
                    _addNotification('Verification Setup has been completed successfully.', this);
                } else if (!response.ok) {
                    console.log("Error Response: ", response)
                    throw Error(response.status);
                } else {
                    _addNotificationError('Check your request body', this);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(`Failed to verify household apps! Getting ${error} status. Please check API request`, this);
                }
            );
        }

    }

    setStartDate = (selectedDate) => {
        const utcDate = new Date(selectedDate.toISOString().split('T')[0]);
        this.setState({ startDate: utcDate });
    }

    setEndDate = (selectedDate) => {
        const utcDate = new Date(selectedDate.toISOString().split('T')[0]);
        this.setState({ endDate: utcDate });
    }

    render() {

        const { schoolList } = this.state;

        const isValidEndDate = (currentDate) => {
            return this.state.startDate ? currentDate.isAfter(this.state.startDate, 'day') : true;
        };
        const isVerificationScreen = () => {
            const { pathname } = this.props.props.location;
            // return pathname.split('/').includes('applicationSetting') ? false : true;
            return false;
        }
        const isVerificationInprogress = () => {
            const { appStatus } = this.state;
            if (['prepare', 'select', 'verify', 'report'].includes(appStatus)) {
                return true;
            }
            return false;
        }

        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className="container" style={{ marginTop: '5px', marginBottom: '10px' }}>
                    <div className='row'>
                        <div className='col-md-12 sectionTitle'>
                            <h2>Verification Settings</h2>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='panel panel-primary'>
                                <div style={{ padding: '15px' }}>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className="uploadFileInfo createmenu-month-group">
                                                    <label className="col-md-8 text-left fw-lighter" style={{ margin: '10px 0px', fontSize: '13px' }}>Verification Start Date</label>
                                                    <div className="input-group col-md-4 col-sm-12 col-xs-12">
                                                        <fieldset disabled={isVerificationInprogress()}>
                                                            <Datetime
                                                                inputProps={{ placeholder: 'Select Date' }}
                                                                ref='calendar' dateFormat="YYYY-MM-DD" timeFormat={false}
                                                                value={this.state.startDate}
                                                                closeOnSelect={true}
                                                                onChange={this.setStartDate}
                                                                renderInput={this.renderInput}
                                                                required

                                                            /></fieldset>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <div className="uploadFileInfo createmenu-month-group">
                                                    <label className="col-md-8 text-left fw-lighter" style={{ margin: '10px 0px', fontSize: '13px' }}>Verification End Date</label>
                                                    <div className="input-group col-md-4 col-sm-12 col-xs-12">
                                                        <fieldset disabled={isVerificationInprogress()}>
                                                            <Datetime inputProps={{ placeholder: 'Select Date' }}
                                                                ref='calendar' dateFormat="YYYY-MM-DD" timeFormat={false}
                                                                value={this.state.endDate}
                                                                closeOnSelect={true}
                                                                isValidDate={isValidEndDate}
                                                                onChange={this.setEndDate}
                                                                renderInput={this.renderInput}
                                                                required
                                                            />
                                                        </fieldset>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <label className="col-md-8 text-left fw-lighter" style={{ margin: '10px 0px', fontSize: '13px' }}>Sampling Type</label>
                                                <div className="input-group col-md-4 col-sm-12 col-xs-12">
                                                    <fieldset disabled={isVerificationInprogress()}>
                                                        <Select
                                                            options={samplingType}
                                                            value={this.state.samplingType}
                                                            onChange={this.handleSamplingType}
                                                        />
                                                    </fieldset>
                                                </div>
                                            </div>
                                            {/* <div className='form-group'>
                                                <label className="col-md-8 text-left fw-lighter" style={{ margin: '10px 0px', fontSize: '13px' }}>Follow-up Frequency</label>
                                                <div className="input-group col-md-4 col-sm-12 col-xs-12">
                                                    <fieldset disabled={isVerificationInprogress()}>
                                                        <Select
                                                            options={options}
                                                            value={this.state.followupFrequency}
                                                            onChange={this.handleFollowUpFrequency}
                                                        />
                                                    </fieldset>
                                                </div>
                                            </div> */}
                                            <div className='form-group'>
                                                <fieldset disabled={isVerificationInprogress()}>
                                                    <label className="col-md-8 text-left fw-lighter" style={{ margin: '10px 0px', fontSize: '13px' }}>
                                                        Follow-up Communication Type
                                                    </label>
                                                    <div className="input-group col-md-4 col-sm-12 col-xs-12" style={{ paddingTop: '10px', fontSize: '13px' }}>
                                                        <div className='form-group'>
                                                            <label><input type='checkbox' checked={this.state.isEmail}
                                                                onChange={this.handleCheckboxEmail} /> Email</label>
                                                        </div>
                                                        <div className='form-group'>
                                                            <label><input type='checkbox' checked={this.state.isSms}
                                                                onChange={this.handleCheckboxSms} /> SMS</label>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <label className="col-md-6 text-left fw-lighter" style={{ fontSize: '13px' }}>Include / Exclude Schools</label>
                                                <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                    <input className="form-control border border-rounded" placeholder='Search..'
                                                        type="text" value={this.state.searchKey}
                                                        onChange={(e) => { this.setState({ searchKey: e.target.value }) }} />
                                                </div>
                                            </div>
                                            <div className='form-group text-left'>
                                                <fieldset disabled={isVerificationInprogress()}>
                                                    <label className="fw-lighter" style={{ fontSize: '13px', marginLeft: '15px' }}><input type='checkbox' checked={this.state.selectAllSchools}
                                                        onChange={() => this.handleSelectAllChange()} />&nbsp; &nbsp; Select All  </label>
                                                </fieldset>
                                            </div>
                                            <fieldset disabled={isVerificationInprogress()}>
                                                <ul className="list-group">
                                                    {schoolList.filter(s => {
                                                        return (this.state.searchKey || '').length > 0 ? s.schoolName.startsWith(this.state.searchKey) : true
                                                    }).map(school => {
                                                        return <li className="list-group-item">
                                                            <label><input id={school.schoolId} type='checkbox' checked={this.state.checkboxStates[school.schoolId]} onChange={() => this.handleCheckboxChange(school.schoolId)} /> {school.schoolName}</label></li>
                                                    })}
                                                </ul></fieldset>
                                        </div>
                                    </div>
                                    <div className='row form-group' >
                                        <div className='col-md-12'>
                                            <label>Verification Contact Details</label>
                                        </div>
                                        <div className='col-md-6'>
                                            <fieldset disabled={isVerificationInprogress()}>
                                                <div className='form-group'>
                                                    <label className="col-md-2 text-left fw-light" style={{ margin: '10px 0px', fontSize: '13px' }}>Name </label>
                                                    <div className="input-group col-md-10 col-sm-12 col-xs-12">
                                                        <input className='form-control rounded' type="text" value={this.state.name} onChange={(e) => { this.setState({ name: e.target.value }) }} />
                                                    </div>
                                                </div>
                                                <div className='form-group'>
                                                    <label className="col-md-2 text-left fw-light" style={{ margin: '10px 0px', fontSize: '13px' }}>Email </label>
                                                    <div className="input-group col-md-10 col-sm-12 col-xs-12">
                                                        <input className='form-control border border-rounded' type="text" value={this.state.email} onChange={(e) => { this.setState({ email: e.target.value }) }} />
                                                    </div>
                                                </div>
                                                <div className='form-group'>
                                                    <label className="col-md-2 text-left fw-light" style={{ margin: '10px 0px', fontSize: '13px' }}>Phone </label>
                                                    <div className="input-group col-md-10 col-sm-12 col-xs-12">
                                                        <input className='form-control border border-rounded' type="text" value={this.state.phone} onChange={(e) => { this.setState({ phone: e.target.value }) }} />
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div className='row' style={{ padding: '15px' }}>
                                    <div className='col-md-12'>
                                        {
                                            isVerificationScreen() ? <div className='row'>
                                                <div className='col-md-12 text-right'>
                                                    <button className='btn btn-primary btn-sm' onClick={this.handlePreviousTabClick} style={{ margin: '0px' }}>Cancel</button> &nbsp;&nbsp;
                                                    <button className='btn btn-success btn-sm' onClick={this.handleVerify} style={{ margin: '0px' }}>Verify</button>
                                                </div>
                                            </div> :
                                                <div className='row'>
                                                    <div className='col-md-12 text-right'>
                                                        <button className='btn btn-primary btn-sm' onClick={() => {
                                                            this.context.router.history.push(`/`)
                                                        }} style={{ margin: '0px' }}>Cancel</button> &nbsp;&nbsp;
                                                        {isVerificationInprogress() ? null : <button className='btn btn-success btn-sm' onClick={this.saveVerifySettings} style={{ margin: '0px' }}>Save</button>}
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        );
    }
}
applicationSetting.contextTypes = {
    router: PropTypes.object.isRequired
};

export default applicationSetting



// WEBPACK FOOTER //
// ./src/components/District/Applications/applicationSetting.jsx